import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

declare module 'react-i18next' {
  interface CustomTypeOptions {
    resources: {
      translation: typeof resources.en.translation;
    };
  }
}

declare module 'i18next' {
  interface TFunction {
    (key: string): string;
  }
}

const resources = {
  en: {
    translation: {
      nav: {
        intro: 'Introduction',
        insurance: 'Insurance Plans',
        calculator: 'Calculator',
        contact: 'Contact'
      },
      intro: {
        name: 'Tian Wei Wei',
        title: 'Senior Financial Advisor',
        description: 'With over 10 years of experience in financial planning and insurance.',
        company: 'ABC Financial Services Ltd.'
      },
      calculator: {
        title: 'Premium Calculator',
        age: 'Age',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        coverageAmount: 'Coverage Amount',
        insuranceType: 'Insurance Type',
        term: 'Term',
        whole: 'Whole Life',
        universal: 'Universal Life',
        smokingStatus: 'Smoking Status',
        no: 'No',
        yes: 'Yes',
        calculate: 'Calculate Premium',
        estimatedPremium: 'Estimated Monthly Premium',
        disclaimer: 'This is an estimate only.'
      },
      insurance: {
        title: 'Our Insurance Products',
        learnMore: 'Learn More',
        product1: {
          name: 'Term Life Insurance',
          description: 'Affordable protection for a specific period.',
          feature1: 'Flexible terms',
          feature2: 'Fixed premiums',
          feature3: 'High coverage amounts'
        }
      },
      contact: {
        title: 'Contact Me',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send Message',
        successMessage: 'Thank you for your message!'
      }
    }
  },
  zh: {
    translation: {
      nav: {
        intro: '介绍',
        insurance: '保险计划',
        calculator: '计算器',
        contact: '联系我们'
      },
      intro: {
        name: '田惟玮',
        title: '高级理财顾问',
        description: '拥有超过10年的财务规划和保险经验。',
        company: 'ABC金融服务有限公司'
      },
      insurance: {
        title: '我们的保险产品',
        learnMore: '了解更多'
      },
      calculator: {
        title: '保费计算器',
        calculate: '计算保费',
        estimatedPremium: '预估月保费',
        disclaimer: '这仅是估算值。'
      },
      contact: {
        title: '联系我',
        submit: '发送消息',
        successMessage: '感谢您的留言！'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
